<template>
  <div class="row">
    <div class="col-12">
      <form role="form">
        <div class="form-check-inline row my-2">
          <input
            class="form-check-input"
            type="checkbox"
            :id="'visible'"
            v-model="parameter_type.visible"
          />
          <label class="form-check-label text-md px-1" :for="'visible'">
            {{ $t("visible") }}
          </label>
        </div>
        <div class="mb-4 text-md">{{ $t("names_different_langs") }}:</div>
        <div v-for="(l, i) in langsFormData" class="form-group row">
          <label class="pl-4 col-sm-2 col-form-label">{{
            l.lang.toUpperCase()
          }}</label>
          <div class="col-sm-10">
            <input
              type="text"
              :name="'langValue-' + l.lang"
              class="form-control"
              v-model="l.name"
              v-validate="'required'"
            />
            <small
              v-show="errors.has('langValue-' + l.lang)"
              class="text-danger"
            >
              {{ $t("field_required") }}
            </small>
          </div>
        </div>
        <div class="hr-line-dashed"></div>
      </form>
    </div>
    <div class="col-sm-12">
      <div
        v-if="editModel && this.roles.id === 1"
        class="btn mx-sm-2 mx-md-0 my-2 btn-danger d-block d-md-inline-block"
        @click.prevent="deleteParamType()"
      >
        {{ $t("remove_parameter") }}
      </div>
      <div
        type="submit"
        class="
          btn
          mx-md-2
          my-2
          btn-primary
          d-block d-md-inline-block
          float-md-right
        "
        v-text="
          editModel ? this.$t('update_parameter') : this.$t('save_parameter')
        "
        @click.prevent="saveParamType()"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ParametersForm',
  data() {
    return {
      defaultLangs: [ 'pl', 'en', 'de', 'es', 'fr', 'it' ],
      parameter_type: {
        lang: [],
        visible: 0
      },
      langsFormData: [],
      editModel: false
    }
  },
  computed: {
    ...mapGetters( 'users', [ 'roles' ] )
  },
  async created() {
    this.$emit( 'loading', true )
    if ( this.$route.params.id !== undefined ) {
      await this.getData()
      this.editModel = true
    }
    this.createdLangsFormData()
    this.$emit( 'loading', false )
  },
  methods: {
    getData() {
      return this.$http
        .get(
          `vnfr/${this.$route.params.env}/parameters-types/${this.$route.params.id}`
        )
        .then( resp => {
          this.parameter_type = resp.data.parameter_type
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    },
    createdLangsFormData() {
      this.defaultLangs.forEach( lang => {
        const elementIndex = this.parameter_type.lang.findIndex( element => element.lang == lang )
        if ( elementIndex !== -1 ) {
          this.langsFormData.push( this.parameter_type.lang[ elementIndex ] )
        } else {
          this.langsFormData.push( this.defaultLangsData( lang ) )
        }
      } )
    },
    defaultLangsData( lang ) {
      return {
        id: null,
        name: '',
        lang: lang
      }
    },

    deleteParamType() {
      this.$emit( 'loading', true )
      this.$http
        .delete(
          `vnfr/${this.$route.params.env}/parameters-types/${this.$route.params.id}`
        )
        .then( resp => {
          this.$toastr.success( 'Usunięte!!' )
          this.$emit( 'loading', false )
          this.$router.push(
            `/przymierzalnia/${this.$route.params.env}/parametryTypy`
          )
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.$emit( 'loading', false )
        } )
    },
    saveParamType() {
      this.$validator.validateAll().then( result => {
        if ( result ) {
          this.$emit( 'loading', true )
          const url = `vnfr/${this.$route.params.env}/parameters-types/${this.$route.params.id}`

          this.parameter_type.lang = this.langsFormData
          this.$http( {
            url:
              this.$route.params.id !== undefined
                ? url
                : `vnfr/${this.$route.params.env}/parameters-types/`,
            method: this.$route.params.id !== undefined ? 'put' : 'post',
            data: this.parameter_type
          } )
            .then( resp => {
              this.$toastr.success( 'Zapisane!!' )
              this.$emit( 'loading', false )
              this.$router.push(
                `/przymierzalnia/${this.$route.params.env}/parametryTypy`
              )
            } )
            .catch( err => {
              this.$toastr.error( err )
              this.$emit( 'loading', false )
            } )
        }
      } )
    }
  }
}
</script>

<style scoped>
a {
  color: white;
}
.text-md {
  font-size: 14px;
}
.form-check-inline {
  display: flex;
}
.form-check-input {
  margin-left: auto;
  width: 16px;
  height: 16px;
}
</style>
